module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("28qal"))).then(() => parcelRequire('5erN3'));